import React from 'react';
import { PaneConfig, PaneState } from './Shuttle';
import BlazeTable from '../blazeTable/BlazeTable';
import TagTextFilter from '../ui/filters/TagTextFilter';
import { Col, Row } from 'react-bootstrap';
import styles from './ShuttlePane.module.css';
import clsx from 'clsx';
import _ from 'lodash';
import { SortConfiguration } from '../../types/rest/paginationTypes';
import BlurredLoader from '../overlays/BlurredLoader';

interface Props {
  paneConfig: PaneConfig;
  onStateChanged: (update: PaneState, reload?: boolean) => void;
}

const ShuttlePane = ({ paneConfig, onStateChanged }: Props) => {
  const { title, state } = paneConfig;

  const updateHandler = (name: string, value: any, reload?: boolean) => {
    const update = { ...state };
    update[name] = value;
    onStateChanged(update, reload);
  };

  const onSearchChangedHandler = _.debounce(value => {
    const update = { ...state };
    update.searchTerm = value;
    onStateChanged(update, true);
  }, 600);

  return (
    <div>
      <BlurredLoader isLoading={paneConfig.state.isLoading}>
        <h2 className={styles.titleText}>
          <span dangerouslySetInnerHTML={{ __html: title }}></span> ({state.totalResults})
        </h2>
        <div className={styles.paneContainer}>
          <div>
            <Row>
              <Col md={6}>
                <TagTextFilter
                  className="mb-3"
                  defaultValue={state.searchTerm}
                  setSearchTerm={onSearchChangedHandler}
                  context={'transactions'}
                />
              </Col>
            </Row>

            <div className={clsx(styles.pane)} style={{ minHeight: '640px' }}>
              <BlazeTable
                data={state.data}
                options={paneConfig.tableOptions}
                expandedItem={state.expanded}
                selectedItems={state.selected}
                onPageChange={activePage => {
                  updateHandler('activePage', activePage, true);
                }}
                onSort={(sort: SortConfiguration) => {
                  updateHandler('sort', sort, true);
                }}
                onSelectionChange={(selectedItems, selectAll) => {
                  const update = { ...state };
                  update.selected = selectedItems;
                  update.selectAll = selectAll;
                  onStateChanged(update);
                }}
                onExpandedItemChange={expandedItemId => {
                  let itemToExpand = expandedItemId;
                  if (state.expanded === itemToExpand) {
                    itemToExpand = null;
                  }
                  updateHandler('expanded', itemToExpand);
                }}
                onPageSizeChange={pageSize => {
                  updateHandler('pageSize', pageSize, true);
                }}
              />
            </div>
          </div>
        </div>
      </BlurredLoader>
    </div>
  );
};

export default ShuttlePane;
